import { AaaGameConceptData, IdXboxGameConceptData } from "../../models/forms";
import { Programs } from "../../models/programsConfig";
import {
  AaaGameConceptDataSet,
  GameConceptsQuery,
  GameConceptState,
} from "../../server/crm/api/models/forms";
import { PaginatedConceptData } from "../../server/crm/api/responses/getFullPaginatedConceptsResponse";
import { ProgramsScope } from "../scopes";
import { createOnboardingAction, createOnboardingAsyncAction } from "./helpers/actionCreators";

export enum GameConceptActions {
  UPDATE_SINGLE_IDXBOX_GAME_CONCEPT = "@gameConcepts/UPDATE_SINGLE_IDXBOX_GAME_CONCEPT",
  CLEAR_SELECTED_IDXBOX_GAME_CONCEPT = "@gameConcepts/CLEAR_SELECTED_IDXBOX_GAME_CONCEPT",
  UPDATE_SINGLE_AAA_GAME_CONCEPT = "@gameConcepts/UPDATE_SINGLE_AAA_GAME_CONCEPT",
  CLEAR_SELECTED_AAA_GAME_CONCEPT = "@gameConcepts/CLEAR_SELECTED_AAA_GAME_CONCEPT",
  GET_GAME_CONCEPTS_LIST = "@gameConcepts/GET_GAME_CONCEPTS_LIST",
  CLEAR_GAME_CONCEPTS_QUERY = "@gameConcepts/CLEAR_GAME_CONCEPTS_QUERY",
  UPDATE_GAME_CONCEPTS_LIST_START = "@gameConcepts/UPDATE_GAME_CONCEPTS_LIST_START",
  UPDATE_GAME_CONCEPTS_LIST_COMPLETED = "@gameConcepts/UPDATE_GAME_CONCEPTS_LIST_COMPLETED",
  UPDATE_GAME_CONCEPTS_LIST_ERROR = "@gameConcepts/UPDATE_GAME_CONCEPTS_LIST_ERROR",
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const gameConceptActions: any = {
  updateSingleIdXboxGameConcept: createOnboardingAction(
    GameConceptActions.UPDATE_SINGLE_IDXBOX_GAME_CONCEPT,
    ProgramsScope,
    (gameConcept: IdXboxGameConceptData & GameConceptState) => ({
      gameConcept,
    })
  ),
  clearSelectedIdXboxGameConcept: createOnboardingAction(
    GameConceptActions.CLEAR_SELECTED_IDXBOX_GAME_CONCEPT,
    ProgramsScope,
    () => ({})
  ),
  updateSingleAaaGameConcept: createOnboardingAction(
    GameConceptActions.UPDATE_SINGLE_AAA_GAME_CONCEPT,
    ProgramsScope,
    (gameConcept: AaaGameConceptData & GameConceptState) => ({
      gameConcept,
    })
  ),
  clearSelectedAaaGameConcept: createOnboardingAction(
    GameConceptActions.CLEAR_SELECTED_AAA_GAME_CONCEPT,
    ProgramsScope,
    () => ({})
  ),
  getGameConcepts: createOnboardingAsyncAction(
    ProgramsScope,
    GameConceptActions.UPDATE_GAME_CONCEPTS_LIST_START,
    (query: PaginatedConceptData, program: Programs) => ({ query, program }),
    GameConceptActions.UPDATE_GAME_CONCEPTS_LIST_COMPLETED,
    (data: AaaGameConceptDataSet | IdXboxGameConceptData, program: Programs) => ({
      data,
      program,
    }),
    GameConceptActions.UPDATE_GAME_CONCEPTS_LIST_ERROR,
    (error: Error) => ({ error })
  ),
  updateGameConceptsList: createOnboardingAction(
    GameConceptActions.GET_GAME_CONCEPTS_LIST,
    ProgramsScope,
    (
      conceptsList: AaaGameConceptDataSet,
      program: Programs,
      conceptsListQuery: GameConceptsQuery
    ) => ({
      conceptsList,
      program,
      conceptsListQuery,
    })
  ),
  clearGameConceptsListQuery: createOnboardingAction(
    GameConceptActions.CLEAR_GAME_CONCEPTS_QUERY,
    ProgramsScope,
    (program: Programs) => ({ program })
  ),
};
